import PropTypes from 'prop-types';
import React from 'react';

import createLabelValueOption from 'App/utils/createLabelValueOption';
import SelectAllField from 'Shared/form/SelectAllField';
import withFormikFields from 'Shared/form/withFormikFields';
import questionPropType from '../types/questionPropType';

const blockedDaysOptions = [
    createLabelValueOption('Monday'),
    createLabelValueOption('Tuesday'),
    createLabelValueOption('Wednesday'),
    createLabelValueOption('Thursday'),
    createLabelValueOption('Friday'),
    createLabelValueOption('Saturday'),
    createLabelValueOption('Sunday'),
];

const QuestionBlockedDaysField = ({ question, fieldValues }) => {
    const blockedDaysValue = fieldValues[`questions.${question.question_id}.blockedDays`];

    if (question.type !== 'date') {
        return null;
    }

    const sortedValue = blockedDaysOptions.filter((o) => !!blockedDaysValue?.find((b) => b.value === o.value));
    return (
        <SelectAllField
            fieldName={`questions.${question.question_id}.blockedDays`}
            label="Blocked Days"
            options={blockedDaysOptions}
            value={sortedValue}
            onValidate={(value) => {
                if (value?.length === 7) {
                    return 'Cannot block all days. You must allow for at least one day to be selected.';
                }
            }}
        />
    );
};

QuestionBlockedDaysField.propTypes = {
    question: questionPropType.isRequired,
    fieldValues: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.shape({}))).isRequired,
};

export default withFormikFields({
    WrappedComponent: QuestionBlockedDaysField,
    fieldNames: [(props) => `questions.${props.question.question_id}.blockedDays`],
});
